export default {
  get: function(){
    return{
      isCollapsed: false
    }
  }
}
